import React from 'react';
import { useImageWithFallback } from './Dv2ElearningMedia';
import { resolveElearningImagePair } from './programConfig';

const ModuleCard = ({ module, index, onOpen }) => {
    const unlocked = Boolean(module.isUnlocked);
    const completed = Boolean(module.isCompleted);
    const imagePair = resolveElearningImagePair({
        moduleId: module.id,
        title: module.title,
        legacyPath: module.imagePath,
        kind: 'module',
    });
    const bg = useImageWithFallback(imagePair.src, imagePair.fallbackSrc);

    return (
        <button
            type="button"
            className={`dv2-el__module dv2-elimg-v2${
                unlocked ? '' : ' is-locked'
            }${completed ? ' is-done' : ''}`}
            style={bg ? { backgroundImage: `url("${bg}")` } : undefined}
            onClick={() => unlocked && onOpen(module)}
            disabled={!unlocked}
            aria-label={
                unlocked
                    ? `Open module ${index + 1}: ${module.title}`
                    : `Locked module ${index + 1}`
            }
        >
            <div className="dv2-el__module-overlay">
                <span className="dv2-el__module-num">
                    {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="dv2-el__module-title">
                    {module.title || `Module ${index + 1}`}
                </h3>
                {!unlocked && module.unLockDateText ? (
                    <p className="dv2-el__module-unlock">
                        Unlocks {module.unLockDateText}
                    </p>
                ) : null}
            </div>
            {completed ? (
                <span className="dv2-el__module-badge" aria-label="Completed">
                    ✓
                </span>
            ) : null}
            {!unlocked ? (
                <span className="dv2-el__module-lock" aria-hidden>
                    <span className="dv2-el__lock-icon" />
                </span>
            ) : null}
        </button>
    );
};

export default ModuleCard;
